// extracted by mini-css-extract-plugin
export default {"element":"StoreGrid_element__xRhNN","container":"StoreGrid_container__5ZKo5","center":"StoreGrid_center__zWFGl"};